import { BalanceOrbit } from "./BalanceOrbit";
import { useCaptainBillingAccount } from "../api/useCaptainBillingAccount";

import { Skeleton } from "@/components/ui/v2/skeleton";
import { CaptainTopbarButton } from "@/features/captain/components/CaptainTopbarButton";
import { useCaptainEnabled } from "@/features/captain/hooks/useCaptainEnabled";
import { useAuth } from "@/lib/hooks/useAuth";
import { UserRole } from "@/types/user/userType";

export function CaptainTopbarControl() {
  const { role, clientId } = useAuth();
  const captainEnabled = useCaptainEnabled();
  const isManager = role === UserRole.MANAGER;
  const { data: account, isPending, isError } = useCaptainBillingAccount(
    clientId ?? undefined,
    isManager && captainEnabled,
  );

  if (!isManager || !captainEnabled || isError) return <CaptainTopbarButton />;

  return (
    <div className="flex items-center gap-2" data-testid="captain-topbar-control">
      {isPending ? (
        <Skeleton className="size-[38px] rounded-full" data-testid="captain-tokens-loading" />
      ) : (
        <BalanceOrbit account={account} />
      )}
      <CaptainTopbarButton />
    </div>
  );
}
